import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from "react";
import Button from "../../../ui/Button/Button";
import UpDownArrow from "../../../assets/upDownArrow";
import { useGameContext } from "../../../game/GameContext/GameContext";
import { calculateBetAmountForInput } from "../../../helpers/formatBetAmount";
import { InputButtonWrapper } from "../../../ui/Input/Input.styled";
var BetAmountButtons = function (_a) {
    var toggleSlider = _a.toggleSlider;
    var _b = useGameContext(), betAmount = _b.betAmount, setBetAmount = _b.setBetAmount, minBet = _b.minBet, maxBet = _b.maxBet, inProgress = _b.inProgress, autoPlayInProgress = _b.autoPlayInProgress, controlPanelDisabled = _b.controlPanelDisabled;
    var isDisabled = useMemo(function () { return inProgress || autoPlayInProgress || controlPanelDisabled; }, [inProgress, autoPlayInProgress, controlPanelDisabled]);
    var multiplyBetAmount = useCallback(function (times) {
        var newBetAmount;
        try {
            newBetAmount = parseFloat(calculateBetAmountForInput(betAmount, times));
        }
        catch (err) {
            newBetAmount = parseFloat(calculateBetAmountForInput(Math.floor(betAmount / 2) * 2, times));
        }
        if (newBetAmount >= minBet && newBetAmount <= maxBet) {
            setBetAmount(newBetAmount);
            return;
        }
        setBetAmount(minBet);
    }, [betAmount, minBet, maxBet, setBetAmount]);
    return (_jsxs(InputButtonWrapper, { children: [_jsx(Button, { variant: "inputButton", onClick: function () { return multiplyBetAmount(0.5); }, disabled: isDisabled, children: "1/2" }), _jsx(Button, { variant: "inputButton", onClick: function () { return multiplyBetAmount(2); }, disabled: isDisabled, children: "2x" }), _jsx(Button, { variant: "inputButton", onClick: toggleSlider, disabled: isDisabled, children: _jsx(UpDownArrow, {}) })] }));
};
export default BetAmountButtons;
//# sourceMappingURL=BetAmount.buttons.js.map